import { render, staticRenderFns } from "./ugc-item.vue?vue&type=template&id=f0e90ea0&scoped=true&"
import script from "./ugc-item.vue?vue&type=script&lang=js&"
export * from "./ugc-item.vue?vue&type=script&lang=js&"
import style0 from "./ugc-item.vue?vue&type=style&index=0&id=f0e90ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e90ea0",
  null
  
)

export default component.exports